import { type EventFilterConditionEdit, type EventFilterEdit } from './EventFilters'

export const isConditionStarted = (condition: EventFilterConditionEdit): boolean => !!condition.type

export const isConditionComplete = (condition: EventFilterConditionEdit): boolean => {
  if (!condition.type || !condition.operator) {
    return false
  }
  if (condition.type === 'host' && (condition.operator === 'me' || condition.operator === 'not_me')) {
    return true
  }
  // A null entry is the "In-person & Phone" option of the service_id condition and counts as a value; empty strings never do
  const values = (condition.value ?? []) as (string | null)[]
  return values.some((value) => (value === null ? condition.type === 'service_id' : value.trim() !== ''))
}

export const isConditionIncomplete = (condition: EventFilterConditionEdit): boolean =>
  !condition.enforced && isConditionStarted(condition) && !isConditionComplete(condition)

export const hasIncompleteConditions = (filters: (EventFilterEdit | null)[]): boolean =>
  filters.some((filter) => filter?.conditions.some(isConditionIncomplete))
